import { memo, useRef } from 'react';

import { AlertModal, AlertModalCloseButton, AlertModalDescription, AlertModalTitle } from '@air/primitive-alert-modal';
import { Button } from '@air/primitive-button';

import { FORMATTED_MAX_FORM_SESSION_ITEMS } from '~/components/ContentCollection/constants';

export const ContentCollectionMaxItemCountModal = memo(({ onClose }: AirModalProps<{ onClose: () => void }>) => {
  const leastDestructiveRef = useRef(null);

  return (
    <AlertModal
      data-testid="CONTENT_COLLECTION_MAX_ITEM_COUNT_MODAL"
      onDismiss={onClose}
      isOpen
      leastDestructiveRef={leastDestructiveRef}
    >
      <div className="mb-3 flex justify-between">
        <AlertModalTitle data-testid="CONTENT_COLLECTION_MAX_ITEM_COUNT_TITLE">
          Maximum upload limit reached.
        </AlertModalTitle>
        <AlertModalCloseButton
          data-testid="CONTENT_COLLECTION_MAX_ITEM_COUNT_CLOSE"
          className="shrink-0"
          onClick={onClose}
        />
      </div>
      <AlertModalDescription className="pt-1 pb-2">
        The maximum number of items allowed per session is {FORMATTED_MAX_FORM_SESSION_ITEMS}. For larger uploads, try
        splitting them into multiple sessions.
      </AlertModalDescription>

      <div className="-mx-6 -mb-6 flex justify-end gap-3 px-6 py-4">
        <Button
          appearance="filled"
          color="blue"
          data-testid="CONTENT_COLLECTION_MAX_ITEM_COUNT_PRIMARY_CTA"
          onClick={onClose}
          ref={leastDestructiveRef}
          size="large"
        >
          Continue
        </Button>
      </div>
    </AlertModal>
  );
});

ContentCollectionMaxItemCountModal.displayName = 'ContentCollectionMaxItemCountModal';
